import { FormGroup } from '@angular/forms';
import { ValidationManager } from 'ng2-validation-manager';
import { ExtraFieldModel } from '../models/extra-field.model';
import { ExtraFieldValidationModel } from '../models/extra-field-validation.model';
import { ExtraFieldValidationParameterValue } from '../models/extra-field-validation-paramater-value.model';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ExtraFieldValidationRuleService } from './extra-field-validation-rule.service';

const translationBaseKey = 'EXTRA_FIELDS_ERRORS';

@Injectable()
export class ExtraFieldValidatonService {
    public validationManager: ValidationManager;
    private extraFields: Array<ExtraFieldModel>;
    private form: FormGroup;

    constructor(private translate: TranslateService) {}

    /**
     * Set form property
     * */
    public setForm(form: FormGroup): void {
        this.form = form;
    }

    /**
     * Set extraFields property
     * */
    public setExtraFields(extraFields: Array<ExtraFieldModel>): void {
        this.extraFields = extraFields;
    }

    /**
     * Build a validation string to be parsed by ValidationManager
     * */
    public buildValidations(): ValidationManager {
        const validations: object = {};

        this.extraFields.forEach((extraField: ExtraFieldModel) => {
            validations[extraField.slug] = this.makeValidationRule(extraField.validations);
        });

        return this.validationManager = new ValidationManager(validations);
    }

    /**
     * Makes a validation rule
     * */
    private makeValidationRule(validations: Array<ExtraFieldValidationModel>): string {
        let rule = '';

        validations.forEach((validation: ExtraFieldValidationModel) => {
            rule = rule.length ?
                rule + '|' + ExtraFieldValidationRuleService.getValidationRuleName(validation.validation_rule.rule)
                : ExtraFieldValidationRuleService.getValidationRuleName(validation.validation_rule.rule);

            if (rule.length && validation.parameters.length) {
                const parameters: Array<string> = validation.parameters
                    .map((param: ExtraFieldValidationParameterValue) => param.value);

                rule = rule + ':' + parameters.join();
            }
        });

        return rule;
    }

    /**
     * Validate a field
     * */
    public validate(slug: string): boolean {
        const extraField = this.extraFields.find(field => field.slug === slug);
        this.validationManager.setValue(slug, this.form.controls[slug].value);

        extraField.validations.forEach((validation: ExtraFieldValidationModel) => {
            const key = translationBaseKey + '.' + validation.validation_rule.rule.toUpperCase();
            const value = validation.parameters.map(param => param.value);

            this.translate.get(key, {
                field: extraField.label,
                value: value.join(', ')
            }).subscribe((trans) => {
                this.validationManager.setErrorMessage(
                    slug,
                    ExtraFieldValidationRuleService.getValidationRuleName(validation.validation_rule.rule),
                    trans
                );
            });
        });

        return !this.validationManager.hasError(slug);
    }

    /**
     * Validate all extra fields
     * */
    public extraFieldsIsValid(): boolean {
        for (const control in this.form.controls) {
            this.validate(control);
        }

        return this.validationManager.isValid();
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/services/extra-field-validaton.service.ts